import {inject} from '@angular/core';
import {CanDeactivateFn, Router} from '@angular/router';
import {AuthService} from '../auth/auth-service';
import {AlertService} from '../../shared/services/alert.service';
import {firstValueFrom} from 'rxjs';
import {StoreDbService} from '../db/store.db.service';
import {TipoPuntoVentaEnum} from '../../shared/enums/tipo-punto-venta-enum';
import {CanExit} from '../interfaces/can-exit-interface';

let confirmationInProgress = false;

function normalizeUrl(url: string | undefined): string {
  return (url ?? '').split(/[?#]/, 1)[0].replace(/\/$/, '');
}

function isNestedNavigation(currentUrl: string, nextUrl: string): boolean {
  return Boolean(currentUrl && nextUrl) && (
    nextUrl.startsWith(`${currentUrl}/`) ||
    currentUrl.startsWith(`${nextUrl}/`)
  );
}

export const ValidaSalirPantallaGuard: CanDeactivateFn<CanExit> = async (
  component,
  currentRoute,
  currentState,
  nextState
) => {
  const auth = inject(AuthService);
  const alertService = inject(AlertService);
  const storeDb = inject(StoreDbService);
  const router = inject(Router);
  const navigation = router.getCurrentNavigation();
  const skipConfirm = navigation?.extras?.state?.['skipConfirm'];
  const internalNavigation = isNestedNavigation(
    normalizeUrl(currentState.url),
    normalizeUrl(nextState?.url)
  );


  if (skipConfirm || internalNavigation) {
    // Navegación interna sin confirmación
    return true;
  }

  // Impide que otro clic en el menú inicie una segunda navegación mientras
  // el usuario todavía está respondiendo el diálogo de la primera.
  if (confirmationInProgress) {
    return false;
  }

  confirmationInProgress = true;
  console.log(storeDb.hasStore());
  const user = auth.currentUser();
  try {

    const confirmar = await alertService.confirm(
      'Cerrar Pantalla',
      '¿Estás seguro que deseas salir?'
    );

    if (!confirmar) return false;

    try {
      const exists = await storeDb.hasStore();

      if (!exists) {
        await firstValueFrom(auth.logout());
        return true;
      }

      const store = await storeDb.getConfig();

      if (!store) return true;

      // Si no es corporativo → logout
      if (store.tipoPV !== TipoPuntoVentaEnum.Corporativo && user) {
        await firstValueFrom(auth.logout());
      }

      return true;

    } catch (error) {
      console.error('Error en IndexedDB:', error);

      // fallback seguro → cerrar sesión
      if (user) {
        await firstValueFrom(auth.logout());
      }

      return true;
    }
  } finally {
    confirmationInProgress = false;
  }
};
